<template>
    <div>

         <Section>
            <div class="top-describe">
                <div class="describe-left">
                    <p><b>{{title}}</b></p>
                    <P>{{remark}}</P>
                </div>
            </div>
        </Section>

        <Section>
            <FilterBox :item-right="40" inline border style="padding: 20px;">
                <FilterBoxItem>
                    <Input style="width: 240px" v-model="mac" :maxlength="25"  placeholder='搜索手环MAC地址'/>  <span style="margin-left: 5px;line-height: 34px;">{{mac.length}}/25</span>
                    <Icon style="padding-left: 7px;" color="#999" size="15" @click="empty" type="ios-close-circle"  />
                </FilterBoxItem>

                <FilterBoxItem>
                    <Button type="primary" @click="search">查找</Button>
                </FilterBoxItem>

            </FilterBox>
            <LabelHeader border>
                <div slot="before">
                    <span class="fs-12px colorA3 mr-10px">手环库列表(共<font color="#307deb">{{allData.length}}</font>条，已筛选<font color="#307deb">{{tableData.length}}</font>条)</span>
                </div>
                <div slot="after">
                    <!--<span class="fs-12px colorA3 mr-10px"><font color="red">{{data.length}}</font>/50</span>-->
                    <Button type="primary" size="large" @click="add">+ 添加手环</Button>
                </div>
            </LabelHeader>
            <LabelHeader border>
                <div slot="before">
                    <span class="fs-12px colorA3 mr-10px">全选(已选 <font color="#307deb">{{selectCell.length}}</font> )个</span>
                    <Button :type="selectCell.length>0?'error':null" :disabled="!selectCell.length>0" @click="openDelModal">删除</Button>
                </div>
            </LabelHeader>

            <div style="padding: 20px">
                <Table border :row-class-name="rowClassName" :columns="columns" :data="tableData" @on-selection-change="onSelectionChange"></Table>
                <Page :total="data.length" ref="pages" :page-size="pageSize" @on-change="pageOnChang" style="text-align: right; margin-top: 20px"></Page>
            </div>

            <Modal v-model="editModal" :mask-closable="false" width="500">
                <p slot="header" style="color:#488bea;">
                    <Icon type="ios-information-circle"></Icon>
                    <span>编辑</span>
                </p>
                <div style="text-align:center">
                    <Form ref="formData" :model="formData" :rules="ruleValidate" :label-width="120" style="padding: 30px"> <!--style="width: 500px; padding: 30px"-->
                        <FormItem label="Mac地址" prop="sn">
                            <Input  v-model="formData.sn" :maxlength="12" style="width: 240px;" placeholder="请填Mac地址..."/>
                            <span style="margin-left: 10px;line-height: 34px;">{{formData.sn.length}}/12</span>
                        </FormItem>
                        <!--<FormItem label="物联网卡" prop="lotCard">
                            <Input  v-model="formData.lotCard" :maxlength="32" style="width: 240px;" placeholder="请填写物联网卡..."/>
                            <span style="margin-left: 10px;line-height: 34px;">{{formData.lotCard.length}}/32</span>
                        </FormItem>-->
                    </Form>
                </div>
                <div slot="footer">
                    <Button  size="large" @click="editModal=false">取消</Button>
                    <Button type="primary" size="large" :loading="loading" @click="submit">确认添加</Button>
                </div>
            </Modal>

            <Modal v-model="delModal" :mask-closable="false" width="400">
                <p slot="header" style="color:#f60;text-align:center">
                    <Icon type="ios-information-circle"></Icon>
                    <span>删除确认</span>
                </p>
                <div style="text-align:center;line-height: 3.5;">
                    <p>删除后，勾选账号将无法登录。</p>
                    <p>是否继续  <span style="color: #ed4014">删除</span>？</p>
                </div>
                <div slot="footer">
                    <Button size="large" @click="delModal=false">取消</Button>
                    <Button type="error" size="large" :loading="loading" @click="batchDel">删除</Button>
                </div>
            </Modal>

        </Section>
    </div>
</template>
<style>
    .ivu-table .demo-table-info-row td{
        color: #ff6600;
    }
</style>
<script>

    import LabelHeader from '@/modules/LabelHeader';
    import FilterBox from '@/modules/FilterBox';
    import FilterBoxItem from '@/modules/FilterBoxItem';
    import qs from 'qs';
    import menuUtil from '../../../utils/menu-list.js';
    import { Table, Page, Button, Modal, Form, FormItem, Input, Select, Option, Row, Col, Icon} from 'iview';
    import Util from '../../../utils/util';

    export default {
        name: "account",
        components: {
            FilterBoxItem,
            FilterBox,
            LabelHeader,
            Table,
            Button,
            Page,
            Form,
            Input,
            Modal,
            FormItem,
            Select,
            Option,
            Row,
            Col,
            Icon
        },
        data () {
            return {

                formData:{
                    sn:"",
                    lotCard:""
                },

                ruleValidate:{
                    lotCard:[{ required: true, message: '请填写物联网卡.', trigger: 'blur' }],
                    sn:[{ required: true, message: '请填写Mac地址.', trigger: 'blur' }],
                },

                title:"",   //标题
                remark:"",  //描述
                loading:false,
                delLoading:false,//删除中状态
                delModal:false,//删除modal
                editModal:false, //编辑弹出modal
                roles:[],   //角色分组
                selectCell:[],  //勾选中的列表数据
                mac:"",

                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'Mac地址',
                        key: 'sn',
                        align: 'center',
                        minWidth: 100
                    },
                    /*{
                        title: '物联网卡',
                        key: 'lotCard',
                        align: 'center',
                        minWidth: 100
                    },*/
                    {
                        title: '使用状态',
                        key: 'status',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            let style = params.row.status?"color:#19be6b":"color:#ed4014";
                            let html = params.row.status?"已使用":"未使用";
                            return h("span",{style:style},html);
                        }
                    },
                    {
                        title: '更新时间',
                        key: 'updatedTime',
                        align: 'center',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('span',Util.dateFormat(params.row.updatedTime,"yyyy-MM-dd hh:mm:ss"));
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 250,
                        render: (h, params) => {
                            let that = this;
                            return h('div', [
                                h('a',{props:{},on:{
                                        click:function () {
                                            that.openEditModal(params.row.id)
                                        }
                                    }}, '修改手环')
                            ]);
                        }
                    }
                ],
                tableData: [],   //列表数据
                allData:[], //总数据
                data:[],
                pageSize:15,  //页数
            }
        },

        methods:{

            //this.$route.params.buildingId

            /**
             * 初始化请求数据
             */
            request(){
                this.$request.get("/back/handRingInventory",{baseURL:this.$HOST}).then((res)=>{
                    if (!res.data.code && res.data.result){
                        this.$refs['pages'].currentPage = 1;
                        this.allData = res.data.result;
                        this.data = res.data.result;
                        this.tableData = this.getDataByPage(res.data.result,1);
                    }
                });
                //qs.stringify({ids:[1,2,3]},{indices: false})
                /*this.$request.get("/back/areaTrigger?buildingId="+this.$Build.buildingId,{baseURL:this.$HOST}).then(function (res) {
                    console.log("areaTrigger ->",res)
                });*/
            },

            /**
             * 查找
             */
            search (){
                if (this.mac && this.mac.length) {
                    this.data = this.allData.filter((tiem)=>{
                        return tiem.sn.indexOf(this.mac)!==-1
                    });
                    this.tableData = this.getDataByPage(this.data,1);
                }else {
                    this.request();
                }
                this.$refs['pages'].currentPage = 1;
            },


            /**
             * 根据分页获取数据
             */
            getDataByPage(data,page){
                let that = this;
                if (data && data.length && page){
                    return data.filter((item,index)=>{
                        return (page-1)*that.pageSize<=index && index<page*that.pageSize;
                    })
                }
                return [];
            },

            /**
             * 分页Chang事件
             */
            pageOnChang (page){
                this.tableData = this.getDataByPage(this.data,page);
            },


            /**
             * 在多选模式下有效，只要选中项发生变化时就会触发
             * @param cell
             */
            onSelectionChange (cell){
                this.selectCell = cell;
            },


            /**
             * 弹出Modal 确认点击事件
             */
            submit(){
                if (this.loading) return;
                let that = this;
                this.$refs["formData"].validate((valid) => {
                    if (valid) {
                        that.loading = true;
                        if (that.formData.id) {
                            that.$request.put("/back/handRingInventory",that.formData,{baseURL:this.$HOST}).then(function (res) {
                                that.loading = false;
                                if (!res.data.code){
                                    that.$Message.success("更新成功！");
                                }else {
                                    that.$Message.error(res.data.message);
                                }
                                that.editModal = false;
                                that.request();
                            });
                        }else {
                            that.$request.post("/back/handRingInventory/create",that.formData,{baseURL:this.$HOST}).then(function (res) {
                                that.loading = false;
                                if (!res.data.code){
                                    that.$Message.success("添加成功！");
                                }else {
                                    that.$Message.error(res.data.message);
                                }
                                that.request();
                                that.editModal = false;
                            });
                        }
                    }
                });
            },


            /**
             * 打开删除Modal
             */
            openDelModal(){
                if (this.selectCell.length){
                    this.delModal = true;
                }
            },


            /**
             * 执行批量删除操作
             */
            batchDel(){
                if (this.selectCell.length) {
                    let ids = [];
                    this.selectCell.forEach(function (item) {
                        ids.push(item.id);
                    });
                    if (this.loading) return;
                    this.loading = true;
                    //headers:{"Content-Type":"application/x-www-form-urlencoded"}
                    this.$request.delete("/back/handRingInventory",{baseURL:this.$HOST,params:{ids:ids},paramsSerializer:params=>{
                            return qs.stringify(params,{arrayFormat:'brackets'});
                        }}).then((res)=>{
                        if (!res.data.code){
                            this.loading = false;
                            this.delModal = false;
                            this.$Message.success("删除成功。");
                            this.selectCell = [];
                            this.request();
                        }
                    })
                }
            },

            empty (){
                this.mac = "";
            },


            /**
             * 添加
             */
            add(){
                this.$refs['formData'].resetFields();
                this.formData={sn:"", lotCard:"",}
                this.editModal = true;
            },


            /**
             * 开打编辑Modal
             * @param id
             */
            openEditModal(id){
                this.$refs['formData'].resetFields();
                this.$request.get("/back/handRingInventory/getOne/"+id,{baseURL:this.$HOST}).then((res)=>{
                    if (!res.data.code && res.data.result){
                        this.formData = res.data.result;
                        this.editModal = true;
                    }
                })
            },

            /**
             * 筛选单点登陆用户 并加css样式
             * @param row
             * @param index
             * @returns {string}
             */
            rowClassName(row, index){
                if (!row.id) {
                    return 'demo-table-info-row';
                }
                return '';
            },


            /**
             * 初始化填充组件的备注
             */
            init(){
                let menuObj = menuUtil.getRemark(this.$router.history.current.path);
                this.title = menuObj.menuName;
                this.remark = menuObj.remark;
            }

        },
        mounted () {
            this.init();
            this.request();
        },

    }
</script>

<style scoped lang="less">
     @import '../../../styles/mainTop';
</style>
